// extracted by mini-css-extract-plugin
export var quillEditor = "_pv-1";
export var variable = "_pv-0";